import _ from 'lodash';
import {DateTime} from 'luxon';
import {createSelector} from 'reselect';

import {isSchedulingLinkOutdated} from '../../../helpers/models/schedulingLinkHelpers';
import {getSchedulingLinks} from '../dataSelectors';
import {getCalendarTimezone} from '../preferences/preferencesSelectors';

export const getFlatSchedulingLinks = createSelector(getSchedulingLinks, (schedulingLinks) =>
  _(schedulingLinks).values().compact().value(),
);

export const getInstantReschedulingLink = createSelector(getFlatSchedulingLinks, (schedulingLinks) =>
  // Each teammate only has 1 instant reschedule link.
  schedulingLinks.find((schedulingLink) => schedulingLink.isCalendarEventReschedulingLink),
);

export const getPermanentSchedulingLinks = createSelector(getFlatSchedulingLinks, (schedulingLinks) =>
  schedulingLinks.filter(
    (schedulingLink) => !schedulingLink.isOneTimeLink && !schedulingLink.isCalendarEventReschedulingLink,
  ),
);

export const getSortedPermanentSchedulingLinks = createSelector(
  getPermanentSchedulingLinks,
  (schedulingLinks) => _.orderBy(schedulingLinks, [isSchedulingLinkOutdated, 'updatedAt'], ['asc', 'desc']),
);

export function makeGetSchedulingLink(getLinkId: () => number) {
  return createSelector(
    [getSchedulingLinks, getLinkId],
    (schedulingLinks, linkId) => schedulingLinks[linkId],
  );
}

export function makeGetTimezone() {
  return createSelector(
    [getCalendarTimezone],
    (calendarTimezone) => calendarTimezone || DateTime.local().zoneName,
  );
}
